import { useContext } from 'react';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { API } from '@trinity/chat';
import { QuantAnalysisAPIContext } from '../contexts/QuantAnalysisAPIContext';

type Props = {
  projectId: number;
  quantAnalysisId: number;
};

type VersionData = API.ProjectsQuantAnalysis.GetProjectQuantAnalysisVersions.Response;
type VersionQueryKey = readonly [string, Props];
type VersionOptions = Omit<UseQueryOptions<VersionData, Error, VersionData, VersionQueryKey>, 'queryKey' | 'queryFn'>;

export const useProjectQuantAnalysisVersionsQuery = (props: Props, options?: VersionOptions) => {
  const apiContext = useContext(QuantAnalysisAPIContext);

  if (!apiContext) {
    throw new Error(
      'useProjectQuantAnalysisVersionsQuery must be used within a QuantAnalysisAPIProvider',
    );
  }

  const queryKey = ['project:quant-analysis-versions', { projectId: props.projectId, quantAnalysisId: props.quantAnalysisId }] as const;

  const query = useQuery({
    queryKey,
    queryFn: async () => {
      return apiContext.getProjectQuantAnalysisVersions({
        projectId: props.projectId,
        quantAnalysisId: props.quantAnalysisId,
      });
    },
    ...options,
  });

  return query;
};
